import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-logout-c783e",
  "use": "icons-logout-c783e-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"icons-logout-c783e\"><path d=\"M7.64 1.777a5.224 5.224 0 0 0 0 10.446v1.5a6.723 6.723 0 1 1 0-13.446zm9.087 5.222-3.516 3.518-1.06-1.06 1.704-1.707H5.96v-1.5h7.897L12.15 4.543l1.06-1.06z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol